import { render, staticRenderFns } from "./match_tickets.vue?vue&type=template&id=6163bba8&"
import script from "./match_tickets.vue?vue&type=script&lang=js&"
export * from "./match_tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports